import React, { memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Info } from 'luxon';
import { DayName } from './elements';
/**
 * Week days
 *
 * This component is in charge of displaying
 * the week day names
 *
 * @param {string} className // Class needed by styled component.
 * @param {string} locale // Local to use to display the weekday names.
 *
 * @return {jsx}
 */

var Weekdays = function Weekdays(_ref) {
  var className = _ref.className,
      locale = _ref.locale;
  var dayNames = Info.weekdays('short', {
    locale: locale
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, dayNames.map(function (dayName) {
    return /*#__PURE__*/React.createElement(DayName, {
      key: dayName
    }, dayName);
  }));
};
/**
 * PropTypes Validation.
 */


var string = PropTypes.string;
Weekdays.propTypes = {
  className: string,
  locale: string
};
/**
 * Default props.
 */

Weekdays.defaultProps = {
  className: '',
  locale: 'en'
};
export default memo(styled(Weekdays).withConfig({
  displayName: "Weekdays",
  componentId: "sc-1plw2lq-0"
})(["display:flex;flex-wrap:nowrap;margin:1.6rem 0 0.8rem;"]));